export interface VerifyResult {
  key: any
  reason: any
}

export const verifyResultKeys = (verifyResults: VerifyResult[]) => {
  return verifyResults.map((result) => result.key)
}

export const hasVerifyResult = (verifyResults: VerifyResult[], key: any) => {
  return (verifyResultKeys(verifyResults) as any).contains(key)
}

export const verifyResultReasons = (verifyResults: VerifyResult[]) => {
  return verifyResults.map((result) => result.reason)
}
